import gql from 'graphql-tag';

export const UpdateIncidentIssue = gql`
  mutation UpdateIncidentIssueBulk($input: UpdateIncidentIssueBulkInput!) {
    updateIncidentIssueBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
